import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import PageHeader from '@/components/PageHeader';
import PointTransactionList from './point-transaction-list';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Point Transactions">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item active>Point Transactions</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <PointTransactionList />
    </Panel>
  );
};

export default Page;
